module.exports = __webpack_public_path__ + "img/bg_proscon_dark.3653e7f5.png";